export default [
  {
    path: '',
    name: 'message',
    component: () => import('./List.vue'),
  },
]
